module.exports = (__parcel__import__("./" + "Native.84d9e557.js")).then(() => parcelRequire('dqcZH'));